import { Injectable } from '@angular/core';
import { BookingsService } from './bookings.service';
import { ToastService } from './toast.service';
import { ApiError } from '../models/common/api-error';
import { TranslocoService } from '@jsverse/transloco';

@Injectable({
  providedIn: 'root'
})
export class UnlockDoorService {
  constructor(
    private bookingsService: BookingsService,
    private toastService: ToastService,
    private translocoService: TranslocoService,
  ) {}

  async unlockDoor(token: string): Promise<boolean> {
    try {
      await this.bookingsService.unlockDoor(token);
      this.toastService.success(
        this.translocoService.translate('common.toast.door-opening'),
        this.translocoService.translate('common.toast.door-opening-title'),
        7500,
      );
      return true;
    } catch (exception) {
      this.toastService.error((exception as ApiError).message);
      console.error(exception);
      return false;
    }
  }
}